import { ProgressBarRounded } from 'baseui/progress-bar';
import { getMarginTagColor } from '@gtintel/platform-utils';
export const MarginProgressBarRounded = ({
  projectMargin
}) => {
  return <ProgressBarRounded progress={+projectMargin} overrides={{
    TrackForeground: {
      style: () => {
        return {
          stroke: getMarginTagColor(projectMargin)
        };
      }
    }
  }} />;
};